export default {
  title: {
    en: 'Cancel your subscription?',
  },
  text: {
    en: `
      Are you sure you want to cancel your Scentbird subscription? This action cannot be undone. 
      If you wish to re-subscribe in the future, you might be put on a waitlist.
    `,
  },
  neverMindButton: {
    en: 'Never mind',
  },
}
